import React from 'react';

// A design-system definition card: facts read back to the user, one row each, the label on the left and the value
// on the right. A long row stacks its value under the label, and an empty or blank value shows as a muted "Not set".
// Put several cards in a <div className='def-cols'> to lay them out side by side; isFullWidth spans every column.
export default function DefinitionCard({ rows = [], isFullWidth = false }) {
  return (
    <div className={isFullWidth ? 'def-card def-full' : 'def-card'}>
      {rows.map((row) => {
        const isEmpty =
          row.value === null || row.value === undefined || (typeof row.value === 'string' && row.value.trim() === '');
        const valueClassName = `v${row.isLong ? ' v-long' : ''}${isEmpty ? ' muted' : ''}`;
        return (
          <div
            key={row.label}
            className={row.isLong ? 'def-row def-row-stacked' : 'def-row'}
          >
            <div className='k'>{row.label}</div>
            <div className={valueClassName}>{isEmpty ? 'Not set' : row.value}</div>
          </div>
        );
      })}
    </div>
  );
}
